import { ContextMenu } from "@/components/ContextMenu";
import { documentAddIcon, plusIcon } from "@repo/skapa";
import { t } from "@repo/translation";
import { formatDateToApi, isDefined } from "@repo/utils";
import {
  addMinutes,
  differenceInMinutes,
  endOfDay,
  startOfDay,
} from "date-fns";
import {
  type MouseEvent,
  type ReactElement,
  cloneElement,
  useState,
} from "react";

import { useCalendarContext } from "../CalendarProvider";

interface ChildProps {
  onContextMenu?: (e: MouseEvent<HTMLDivElement>) => void;
}

interface Props {
  date: Date;
  emailId?: string;
  selectedTeam?: number;
  onClick?: () => void;
  menuRef: HTMLDivElement | null;

  children: ReactElement<ChildProps>;
}
export const CalendarContextMenu = ({
  date,
  emailId,
  selectedTeam,
  onClick,
  menuRef,
  children,
}: Props) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { taskCopy, saveTask } = useCalendarContext();

  const menuItems = [
    taskCopy !== undefined
      ? {
          icon: documentAddIcon,
          label: t("action.paste_event"),
          onClick: () => {
            if (taskCopy) {
              const lengthOfTask = differenceInMinutes(
                taskCopy.end,
                taskCopy.start
              );
              const newEndTime = addMinutes(date, lengthOfTask);
              saveTask({
                id: taskCopy.id,
                emailId, // Target email
                assignedTeam: selectedTeam,
                startDate: taskCopy.allDay
                  ? formatDateToApi(startOfDay(date))
                  : formatDateToApi(date),
                endDate: taskCopy.allDay
                  ? formatDateToApi(endOfDay(taskCopy.start))
                  : formatDateToApi(newEndTime),

                makeCopy: true,
              });
            }
          },
        }
      : undefined,
    onClick
      ? {
          icon: plusIcon,
          label: t("action.add_event"),
          onClick: () => {
            onClick();
          },
        }
      : undefined,
  ].filter(isDefined);

  return (
    <>
      <ContextMenu
        elRef={menuRef}
        isOpen={isMenuOpen}
        setIsOpen={setIsMenuOpen}
        menuItems={menuItems}
      />
      {cloneElement(children, {
        onContextMenu: (e: MouseEvent<HTMLDivElement>) => {
          e.preventDefault();
          setIsMenuOpen(true);
          return;
        },
      })}
    </>
  );
};
